const NON_ALPHANUMERIC_REGEX = /[\W_]/gi;

const codify = (value) =>
  value && typeof value === 'string'
    ? value.replaceAll(NON_ALPHANUMERIC_REGEX, '').toLowerCase()
    : value;

export default codify;
